import { render, staticRenderFns } from "./AssessmentReport.vue?vue&type=template&id=63a19004&scoped=true"
import script from "./AssessmentReport.vue?vue&type=script&lang=js"
export * from "./AssessmentReport.vue?vue&type=script&lang=js"
import style0 from "./AssessmentReport.vue?vue&type=style&index=0&id=63a19004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a19004",
  null
  
)

export default component.exports